"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _sentry = _interopRequireDefault(require("@spothero/utils/sentry"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ErrorBoundary extends _react.Component {
  static defaultProps = {
    reportToSentry: true
  };
  state = {
    error: null
  };
  componentDidCatch(error, info) {
    const {
      reportToSentry,
      onError
    } = this.props;
    this.setState({
      error
    });
    if (onError) {
      onError(error, info);
    }
    if (reportToSentry) {
      _sentry.default.addData(info);
      _sentry.default.sendMessage({
        message: error.message,
        level: 'error'
      });
    }
  }
  render() {
    const {
      children,
      className,
      errorComponent
    } = this.props;
    const {
      error
    } = this.state;
    const classes = (0, _classnames.default)('ErrorBoundary', className);
    if (error) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, errorComponent, !errorComponent && /*#__PURE__*/_react.default.createElement("div", {
        className: "ErrorBoundary-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ErrorBoundary-info"
      }, "An error has occurred."), /*#__PURE__*/_react.default.createElement("div", {
        className: "ErrorBoundary-info"
      }, "Please refresh the page and try again.")));
    }
    return children;
  }
}
exports.default = ErrorBoundary;